const TopBanner = ({ about }) => {
  return (
    <div
      className="xl:h-[470px] lg:h-[370px] rounded-[15px] flex flex-col-reverse md:flex-row items-center justify-center p-14 md:p-16 relative overflow-hidden"
      style={{ backgroundColor: about.bannerBackgroundColor }}
    >
      <img
        src={process.env.REACT_APP_BACKEND_URL + "public/" + about.bannerImage}
        style={{ height: "auto" }}
        alt="about image"
         onError={(e) => {
                e.currentTarget.src = require("../../assets/images/spotlight2.png");
              }}
        className=" md:absolute 2xl:-bottom-12 2.5xl:left-32 2xl:left-20 lg:-bottom-12  lg:left-16 md:-bottom-5 md:left-12 xl:w-[207px] lg:w-[160px] md:w-[120px] w-[134px] h-[200px] mt-5 -mb-20 md:mt-0 md:mb-0"
      />
      <p
        style={{ color: about.bannerHeading1Color }}
        className="text-left  md:translate-x-16 2.5xl:translate-x-0 text-white 1xl:text-6xl 2.5xl:text-70pt sm:text-3xl lg:text-5xl text-4xl 2.5xl:max-w-[880px] 1xl:max-w-[750px] lg:max-w-[600px] md:max-w-[400px] max-w-[600px]"
      >
        {about.bannerHeading1}{" "}
        <span style={{ color: about.bannerHeading2Color }}>
          {about.bannerHeading2}
        </span>
      </p>
    </div>
  );
};

export default TopBanner;
